import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useLocalize } from '@treams/treams-hooks';
import { EvaluationFormFragment } from '@treams/treams-network';
import { Button, FlexGap, Paragraph, tokens } from '@treams/treams-ui';

import { SelectConversationTypeModal } from './components';

type Props = {
	forms: EvaluationFormFragment[];
	value?: string;
	onChange: (evaluationFormId: string) => void;
};

export const SelectConversationType = ({ forms, value, onChange }: Props) => {
	const [modalVisible, setModalVisible] = useState(false);

	const { t } = useTranslation('', {
		keyPrefix: 'evaluations.create.modal.form.selectConversationType',
	});
	const { localize } = useLocalize();

	const selectedForm = forms.find((form) => form.id === value);
	const selectedFormName = selectedForm ? localize(selectedForm.title).text : t('noSelection');

	return (
		<>
			<FlexGap
				alignItems="center"
				justifyContent="space-between"
				gap={tokens.gap.group}
				mb={3}
				width="100%"
			>
				<Paragraph mb={0} minWidth={0} flex={1}>
					{selectedFormName}
				</Paragraph>
				<Button
					type="secondary"
					title={t('selection.title')}
					onClick={() => setModalVisible(true)}
				/>
			</FlexGap>
			<SelectConversationTypeModal
				selected={selectedForm}
				visible={modalVisible}
				onClose={() => setModalVisible(false)}
				onSave={(form) => onChange(form.id)}
				forms={forms}
			/>
		</>
	);
};
